import { render, staticRenderFns } from "./AppModule.vue?vue&type=template&id=8b49283e&"
import script from "./AppModule.vue?vue&type=script&lang=js&"
export * from "./AppModule.vue?vue&type=script&lang=js&"
import style0 from "./AppModule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports